// extracted by css-extract-rspack-plugin
export default {"TabList":"SpecificDatePicker-modules__TabList___soiQ9"};